import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { message, Spin, Alert, Button } from 'antd';
import api from '../../services/api'; // Adjust the path as necessary
import AppLayout from '../../layouts/AppLayout'; // Use your layout

function DiscordCallbackLink() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
    const errorParam = queryParams.get('error');
    const errorDescription = queryParams.get('error_description');

    if (errorParam) {
      setError(`Erro do Discord: ${errorDescription || errorParam}`);
      setLoading(false);
      return;
    }

    if (!code) {
      setError('Código de autorização do Discord não encontrado na URL.');
      setLoading(false);
      return;
    }

    const linkAccount = async () => {
      try {
        // The redirect URI sent here MUST EXACTLY match the one used 
        // to initiate the flow in the Settings page
        const redirectUri = window.location.origin + '/discord/callback/link'; 
        
        await api.post('/user/discord/link', { code, redirectUri });
        
        message.success('Conta Discord vinculada com sucesso!');
        navigate('/dashboard/settings'); // Redirect back to settings
      } catch (err) {
        console.error("Erro ao vincular Discord:", err);
        const apiErrorMessage = err.response?.data?.message || 'Falha ao vincular conta Discord. Tente novamente.';
        setError(apiErrorMessage);
        message.error(apiErrorMessage);
      } finally {
        setLoading(false);
      }
    };

    linkAccount();
  }, [location, navigate]);

  return (
    <AppLayout page="discord-link-callback" title="Vinculando Discord...">
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 200px)' }}>
        {loading && <Spin size="large" tip="Processando autorização do Discord..." />}
        {error && (
          <Alert
            message="Erro ao Vincular Discord"
            description={error}
            type="error"
            showIcon
            action={
              <Button size="small" type="primary" onClick={() => navigate('/dashboard/settings')}>
                Voltar para Configurações
              </Button>
            }
          />
        )}
      </div>
    </AppLayout>
  );
}

export default DiscordCallbackLink; 